import React from "react";
import { PRODUCT_DATA } from "../../utils/ProductMapper/MapProduct";
import { PRODUCT_ORDER } from "./quoteOptions";
import "./QuoteForm.css";

// Logo tiles for picking a CAD platform, in place of a <select>. Six options
// with recognisable logos are faster to scan as a grid than as a dropdown the
// user has to open before they can see what's on offer.
//
// `invalid` paints the whole grid red rather than showing a message here — the
// caller owns the error text, so it can sit wherever its layout wants it.
export default function PlatformTiles({ value, onChange, invalid = false, innerRef }) {
  return (
    <div className={`platform-grid${invalid ? " is-invalid" : ""}`} ref={innerRef}>
      {PRODUCT_ORDER.map((code) => {
        const product = PRODUCT_DATA[code];
        if (!product) return null;
        return (
          <button
            type="button"
            key={code}
            className="platform-tile"
            aria-pressed={value === code}
            onClick={() => onChange(code)}
          >
            <img src={product.logo} alt="" />
            <span>{product.shortName}</span>
          </button>
        );
      })}
    </div>
  );
}
